export default __webpack_public_path__ + "static/banner-ecommerce-development-25e7ff6da9cbdae86a27140d10605271.jpg";